import { useEffect, useState } from "react";

const CaaStatusDropDownCell = ({ value, setValue,className }) => {
  const handleAction = (e) => {
    setValue((prev) => ({
      ...prev,
      ["caa_status"]: e.target.value,
    }));
  };

  return (
    <div
      className={`${className} flex h-full  w-full flex-col gap-2 rounded-[4px] bg-gray-100`}
    >
      <div className="h-full rounded bg-transparent px-[1px] py-[1px]">
        <select
          className=" w-full  bg-transparent py-[0.4rem] text-[14px] text-[#868686]   focus:outline-none"
          value={value?.caa_status || ""}
          onChange={(e) => handleAction(e)}
        >
          <option value="" className="">
            All
          </option>
          <option value="S" className="">
            Auto Approved
          </option>
          <option value="A" className="">
            Approved
          </option>
          <option value="P" className="">
            Pending
          </option>
          <option value="O" className="">
            Overdue
          </option>
        </select>
      </div>
    </div>
  );
};

export default CaaStatusDropDownCell;
